import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import '../../internals/89afd3114d9c158f62e0e21a82cf39c4eddcf7acec690559797227aa316f9264.cfe-internal.js';
import { useIsomorphicLayoutEffect } from '../e6bd8d9d193665651547f77cb2adacf0dae81d061654707a931bdfc0fd619642.cfe-internal.js';
import { useDragSource } from './e5345d9a5feba3b5d511cc5651090dd3a4e9dc76b8debdf7f87c78227e0827e0.cfe-internal.js';
import { useDragDropManager } from '../2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { useDragType } from './a08d6039727702c3f63b14dec3075a14987e07d3dbbb0f558d4e5893fc300481.cfe-internal.js';
import { registerSource } from '../../internals/06b39944ae11f4054ab74e07df5a51b41fa8320b8b5de5e22f31d0e4a8aa29db.cfe-internal.js';

function useRegisteredDragSource(spec, monitor, connector) {
  var manager = useDragDropManager();
  var handler = useDragSource(spec, monitor, connector);
  var itemType = useDragType(spec);
  useIsomorphicLayoutEffect(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = registerSource(itemType, handler, manager),
        _registerSource2 = _slicedToArray(_registerSource, 2),
        handlerId = _registerSource2[0],
        unregister = _registerSource2[1];
      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
    return;
  }, [manager, monitor, connector, handler, itemType]);
}

export { useRegisteredDragSource };
